import { gql } from '@apollo/client'

const SUBMIT_HEALTH_METRICS = gql`
  mutation submitHealthMetrics($healthMetricsData: [HealthMetricData!], $date: ISO8601Date!) {
    submitHealthMetrics(healthMetricsData: $healthMetricsData, date: $date) {
      success
    }
  }
`

export default SUBMIT_HEALTH_METRICS
